module.exports = "/_next/static/images/3b0cbe4ae0a57f086b7634284ffd461a-wellDoneHiFive.svg";